import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { Injector, NgModule, inject, provideAppInitializer } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule, Title } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { ErrorTemplateComponent } from '@core/components/error-template/error-template.component';
import { coreRoutes } from '@core/core.routes';
import { appInitializerFactory } from '@core/services/app-initializer-factory';
import { AuthHeaderInterceptor } from '@core/services/auth-header-interceptor.service';
import { PreloadingStrategyService } from '@core/services/preloading-strategy.service';
import { UserService } from '@core/store/user/user.service';
import { AkitaNgRouterStoreModule } from '@datorama/akita-ng-router-store';
import { AkitaNgDevtools } from '@datorama/akita-ngdevtools';
import { environment } from '@environments/environment';
import { API_ROOT } from '@shared/constants/api-root.const';
import { RequestQuoteModule } from '@shared/modals/request-quote/request-quote.module';
import { CookieService } from '@shared/services/cookie.service';
import { HeaderComponent } from './components/header/header.component';
import { CoreComponent } from './core.component';
import { ToastContainerComponent } from './components/toast-container/toast-container.component';
import { MAT_RIPPLE_GLOBAL_OPTIONS } from '@angular/material/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AuthService, LOGIN_CONFIG } from '@zitemedia/zitadel-sso-frontend';
import { AmApiKeyInterceptor } from '@core/interceptors/am-api-key.interceptor';


@NgModule({ imports: [CommonModule,
        // SignInModule,
        BrowserModule,
        RouterModule.forRoot(coreRoutes, {
            initialNavigation: 'enabledBlocking',
            paramsInheritanceStrategy: 'always',
            anchorScrolling: 'enabled',
            scrollPositionRestoration: 'top',
            preloadingStrategy: PreloadingStrategyService,
            onSameUrlNavigation: 'reload',
        }),
        AkitaNgRouterStoreModule,
        environment.production ? [] : AkitaNgDevtools,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        RequestQuoteModule,
        CoreComponent, HeaderComponent, ErrorTemplateComponent, ToastContainerComponent], providers: [
        PreloadingStrategyService,
        Title,
        provideAppInitializer(() => {
            const initializerFn = (appInitializerFactory)(inject(Injector), inject(CookieService), inject(UserService), inject(Title));
            return initializerFn();
        }),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthHeaderInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AmApiKeyInterceptor,
            multi: true
        },
        {
            provide: API_ROOT,
            useValue: environment.API_ROOT
        },
        {
            provide: MAT_RIPPLE_GLOBAL_OPTIONS,
            useValue: {
                disabled: true
            }
        },
        {
            provide: AuthService,
            useClass: AuthService
        },
        {
            provide: LOGIN_CONFIG,
            useValue: {
                apiRoot: environment.API_ROOT,
                successCallbackUrl: '/',
                errorCallbackUrl: '/login'
            }
        },
        provideHttpClient(withXhr(), withInterceptorsFromDi())
    ] })
export class CoreModule {
}
